import { formatDateTime, parseDateTime } from 'utils/dates/date.utils';
import { getMarineWidgetLayout } from '../../../utils/marineForecastWidget.utils';

export const getTideTableWidgetLayout = getMarineWidgetLayout;

export const getTideTableWidgetLocations = (locations = []) =>
  locations.filter((location) => location?.forecasts?.length);

export const getTideTableWidgetLocationOptions = (locations) =>
  locations.map(({ locationKey, locationName }) => ({
    label: locationName,
    value: locationKey,
  }));

export const getTideTableWidgetForecastDayLabel = (forecast) => {
  const forecastDate = parseDateTime(forecast?.iso8601);

  if (!forecastDate) return 'Forecast';

  return new Intl.DateTimeFormat(undefined, { weekday: 'short' }).format(forecastDate);
};

export const getTideTableWidgetForecastDateLabel = (forecast) => {
  const forecastDate = parseDateTime(forecast?.iso8601);

  if (!forecastDate) return 'Date unavailable';

  return new Intl.DateTimeFormat(undefined, {
    month: 'short',
    day: 'numeric',
  }).format(forecastDate);
};

export const getTideTableWidgetTileAriaLabel = (forecast) =>
  `Select tide forecast for ${formatDateTime(
    forecast?.iso8601,
    'long',
    'an unavailable date',
    true,
  )}`;
